import React, { useState } from 'react';
import { footerLinks } from '../data/mock';
import { motion } from 'framer-motion';

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (newsletterEmail) {
      setSubscribed(true);
      setTimeout(() => setSubscribed(false), 3000);
      setNewsletterEmail('');
    }
  };

  return (
    <footer className="bg-[#0f1629] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
          {/* Logo and newsletter */}
          <div className="max-w-sm">
            <img
              src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/69e0a8442fde5f7cc3b2d3c6_newlogoxeno-blue11.png"
              alt="Xeno Logo"
              className="h-8 mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 mb-2">
              AI Powered Customer Engagement Suite
            </p>
            <div className="flex items-center gap-4 mb-6">
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cec851558e8d2e47950_image%206718.webp"
                alt="ISO"
                className="h-10 object-contain"
              />
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cebaa6fb79a9289a746_image%206715.webp"
                alt="SOC2"
                className="h-10 object-contain"
              />
            </div>
            <p className="text-xs text-gray-500 mb-6">
              <strong className="text-gray-400">Our Offices:</strong> Dubai | Delhi | Mumbai | Bengaluru
            </p>

            {/* Newsletter */}
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-white mb-1">Xeno Pulse</h4>
              <p className="text-xs text-gray-400 mb-3">
                Level up your Retail Marketing understanding!
              </p>
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  placeholder="A weekly newsletter right in your inbox"
                  className="flex-1 px-3 py-2 bg-[#1a2035] border border-gray-700 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#2563EB] rounded-lg text-xs font-semibold hover:bg-[#1d4ed8] transition-colors"
                >
                  Subscribe
                </button>
              </form>
              {subscribed && (
                <p className="mt-2 text-xs text-green-400">
                  Thank you for subscribing!
                </p>
              )}
            </div>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Solutions</h4>
              <ul className="space-y-2.5">
                {footerLinks.solutions.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Customer Success Stories</h4>
              <ul className="space-y-2.5">
                {footerLinks.customerSuccess.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Industries</h4>
              <ul className="space-y-2.5">
                {footerLinks.industries.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
              <ul className="space-y-2.5">
                {footerLinks.resources.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
              <ul className="space-y-2.5">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors inline-flex items-center gap-2">
                      {link.label}
                      {link.badge && (
                        <span className="text-[10px] bg-green-600 text-white px-1.5 py-0.5 rounded-full font-semibold">
                          {link.badge}
                        </span>
                      )}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">©2026 Xeno. All Rights Reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors">
              Term of Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
